import { stringifySearchWith } from "@tanstack/react-router";

// parses a search-param value back into a string array. matched pair with the
// custom stringifier below, which emits string arrays as comma-separated
// values rather than JSON.
//
// accepts:
// - native arrays (from navigate({ search: { x: ["a","b"] } }), or from legacy
//   JSON-array URLs that TSR's default parser already turned into an array)
// - comma-separated strings (the format we now emit)
export function coerceToStringArray(val: unknown): unknown {
  if (Array.isArray(val)) return val;
  if (typeof val !== "string") return val;
  return val.split(",").filter(Boolean);
}

// emit arrays of plain strings as comma-separated values instead of JSON.
// JSON arrays in URLs contain [, ], ", which chat clients (Teams, Outlook,
// safelinks) frequently re-encode asymmetrically when sharing: producing
// malformed links the recipient cannot open. Comma-separated UUIDs (and other
// simple strings) survive that re-encoding because they only contain
// URL-unreserved chars. See coerceToStringArray above for the matching parse
// logic.
const stringify = (val: unknown): string => {
  if (
    Array.isArray(val) &&
    val.length > 0 &&
    val.every((v) => typeof v === "string" && !v.includes(","))
  ) {
    return val.join(",");
  }
  return JSON.stringify(val);
};

// the router's search serializer, exported so hand-built redirect hrefs
// round-trip through the same format as regular navigations
export const appStringifySearch = stringifySearchWith(stringify, JSON.parse);
